import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faXTwitter,
  faWhatsapp,
  faTelegram,
} from "@fortawesome/free-brands-svg-icons";
export const socialHandlesObject = [
  {
    logo: (
      <FontAwesomeIcon
        className="socialIcon"
        icon={faFacebook}
        size="2x"
        style={{ color: "white" }}
      />
    ),
    link: "https://www.facebook.com/ezzytechs",
  },
  {
    logo: (
      <FontAwesomeIcon
        className="socialIcon"
        icon={faXTwitter}
        size="2x"
        style={{ color: "white" }}
      />
    ),
    link: "https://www.x.com/Ezzytechs",
  },
  {
    logo: (
      <FontAwesomeIcon
        className="socialIcon"
        icon={faWhatsapp}
        size="2x"
        style={{ color: "white" }}
      />
    ),
    link: "https://wa.link/bsx8eq",
  },
  {
    logo: (
      <FontAwesomeIcon
        className="socialIcon"
        icon={faTelegram}
        size="2x"
        style={{ color: "white" }}
      />
    ),
    link: "https://t.me/Ezzytechs",
  },
];
